<section class="countDown-stopwatch" *ngIf="showCountdownBox">
    <div class="row">
        <h3 class="ml-auto mr-auto">Desea agregar m&aacute;s tiempo a la compulsa?</h3>
    </div>
    <div class="row d-flex ml-1 mr-1">
        <button class="mr-1 mb-2 btn btn-labeled btn-outline-primary" (click)="increaseEventCountDown(15)" [disabled]="!countdown15Enabled">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-clock"></i>
            </span>
            <span>+15 min.</span>
        </button>
        <button class="mr-1 mb-2 btn btn-labeled btn-outline-primary" (click)="increaseEventCountDown(30)" [disabled]="!countdown30Enabled">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-clock"></i>
            </span>
            <span>+30 min.</span>
        </button>
        <button class="mr-1 mb-2 btn btn-labeled btn-outline-primary" (click)="increaseEventCountDown(45)" [disabled]="!countdown45Enabled">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-clock"></i>
            </span>
            <span>+45 min.</span>
        </button>
        <button class="mr-1 mb-2 btn btn-labeled btn-outline-primary" (click)="increaseEventCountDown(60)" [disabled]="!countdown60Enabled">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-clock"></i>
            </span>
            <span>+60 min.</span>
        </button>
    </div>
</section>

<div class="d-flex align-items-center">
    <h3>C&oacute;digo de la compulsa: {{ActiveAdjust.AdjustCode}}</h3>
    <i class="ml-2">Tiempo restante: <b>{{hours}} hrs {{minutes}} min {{seconds}} seg</b></i>
</div>
<div class="d-flex align-items-center" *ngIf="adjustMoveDateSuccess">
    <i>Informaci&oacute;n mostrada a partir de la {{AdjustMoveDate.Type}} con fecha: <b>{{AdjustMoveDate.MoveDate}}</b></i>
</div>

<div class="col" *ngIf="!adjHistory">
    <div class="row form-group">
        <!-- inicio botones de conteo -->
        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-success" (click)="adjWeb()" *ngIf="!adjApkRunning && !adjWebRunning && showWebPhisical">
            <!-- Toma de inventario -->
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-globe"></i>
            </span>
            <span>Conteo f&iacute;sico en WEB</span>
        </button>

        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-danger" (click)="cancelAdjweb()" *ngIf="adjWebRunning">
            <!-- Cancelar toma de inventario -->
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-globe"></i>
            </span>
            <span>Cancelar Conteo f&iacute;sico en WEB</span>
        </button>


        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-warning " (click)="adjApk()" *ngIf="!adjApkRunning && !adjWebRunning && showApkPhisical">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-mobile-alt"></i>
            </span>
            <span>Conteo f&iacute;sico en APK</span>
        </button>

        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-danger" (click)="cancelAdj('APK')" *ngIf="adjApkRunning">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-mobile"></i>
            </span>
            <span>Cancelar conteo f&iacute;sico en APK</span>
        </button>

        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-primary " (click)="adjPT()" *ngIf="!adjApkRunning && !adjWebRunning && !adjPTRunning && showButtonPT">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-mobile-alt"></i>
            </span>
            <span>Conteo f&iacute;sico en PT</span>
        </button>

        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-danger" (click)="cancelAdj('PT')" *ngIf="adjPTRunning && showButtonPT && showCancelPT">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-mobile"></i>
            </span>
            <span>Cancelar conteo f&iacute;sico en PT</span>
        </button>

        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-danger" (click)="cancelAdjust()" *ngIf="!adjApkRunning && !adjWebRunning">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-times"></i>
            </span>
            <span>Cancelar compulsa</span>
        </button>
        <!-- fin botones de conteo -->

        <!-- inicio bootnes guardado -->
        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-primary" (click)="saveAdjust()" *ngIf="displaySave" [disabled]="!enableSave">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fa fa-save"></i>
            </span>
            <span>Guardar compulsa</span>
        </button>
        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-primary " (click)="signAdjust()" *ngIf="displaySign" [disabled]="!enableSign">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-file-signature"></i>
            </span>
            <span>Firmar compulsa</span>
        </button>
        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-primary " (click)="reopenAdjust()" *ngIf="displayReopen" [disabled]="!enableReopen">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-undo-alt"></i>
            </span>
            <span>Reabrir compulsa</span>
        </button>

        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-primary" (click)="saveAdjustApk()" *ngIf="displaySaveAPK" [disabled]="!enableSaveAPK">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fa fa-save"></i>
            </span>
            <span>Guardar Conteo APK</span>
        </button>
        <!-- fin botones guardado -->

        <!-- adjuntos -->
        <button type="button" class="mr-2 mb-2 btn btn-labeled btn-outline-primary" (click)="btnAttachement()" *ngIf="displayAttch">
            <span class="btn-label">
                <i style="font-size: 1.5em;margin-top:4px;" class="fa fa-cloud-upload-alt"></i>
            </span>
            <span>Documentos Adjuntos</span>
        </button>
        <!-- fin adjuntos -->

    </div>
</div>

<div class="row">
    <div class="col-12 overflow-hidden text-dark">
        <!-- style="max-height: 30em;" -->
        <div class="overflow-auto">
            <div *ngFor="let line of adjustLines" [ngClass]="{'static-header':line.IsHeader}">

                <!-- inicio lineas padres -->
                <div class="d-flex">
                    <!-- inicio encabezado de filas -->
                    <div class="col-3 p-0" [ngClass]="line.StyleClass">
                        <div class="border pl-2 h-100 align-content-center" *ngIf="line.Childrens.length==0">
                            <label *ngIf="!line.IsHeader" class="mb-0">{{line.Description}}</label>
                            <h4 *ngIf="line.IsHeader" class="mb-0"><b>{{line.Description}}</b></h4>
                        </div>

                        <div class="border pl-2 pointer d-flex h-100 align-items-center" (click)="line.Collapsed= !line.Collapsed" *ngIf="line.Childrens.length>0">
                            <label class="mb-0">{{line.Description}}</label>
                            <label class="ml-auto mr-2 mb-0">
                                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-chevron-right" *ngIf="line.Collapsed"></i>
                                <i style="font-size: 1.5em;margin-top:4px;" class="fas fa-chevron-down" *ngIf="!line.Collapsed"></i>
                            </label>
                        </div>
                    </div>
                    <!-- fin encabezado de filas -->

                    <!-- inicio columnas de equipo controlado -->
                    <div class="col-12 p-0">
                        <div class="d-flex">
                            <div *ngFor="let cell of line.Detail" [ngClass]="line.StyleClass" class="border d-flex align-items-center justify-content-center" style="width: 8em;height: 3em;">
                                <h4 *ngIf="line.IsHeader" class="m-0"><b>{{cell.ContainerCode}}</b></h4>

                                <label *ngIf="!line.IsHeader && !cell.IsEditable" class="d-block text-center m-0">{{globalFunctionService.separatorFormatter(cell.Quantity)}}</label>
                                <input *ngIf="!line.IsHeader && cell.IsEditable" type="number" min="0"
                                       class="form-control text-center"
                                       [(ngModel)]="cell.Quantity"
                                       [disabled]="!canEditAdjust"
                                       onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                       onfocus="if(this.value==='0'){this.value=''}"
                                       onfocusout="if(this.value===''||this.value===null||this.value===undefined){this.value=0;}"
                                       (ngModelChange)="updateTotalValue(line, cell)" />
                            </div>
                        </div>
                    </div>
                    <!-- fin columnas de equipo controlado -->
                </div>
                <!-- fin  lineas padres -->

                <!-- inicio hijos colapsables -->
                <div *ngIf="line.Childrens.length>0" [(collapse)]="line.Collapsed" [isAnimated]="false">
                    <div class="d-flex" *ngFor="let children of line.Childrens">
                        <div class="col-3 p-0" [ngClass]="children.StyleClass">
                            <div class="border pl-4 d-flex h-100 align-items-center">
                                <label class="mb-0 ">{{children.Description}}</label>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                            <div class="d-flex">
                                <div *ngFor="let cell of children.Detail" [ngClass]="children.StyleClass" class="border d-flex align-items-center justify-content-center" style="width: 8em;height: 3em;">
                                    <label *ngIf="children.IsHeader" class=" m-0">{{cell.ContainerCode}}</label>

                                    <label *ngIf="!line.IsHeader && !cell.IsEditable" class="d-block text-center m-0">{{globalFunctionService.separatorFormatter(cell.Quantity)}}</label>
                                    <input *ngIf="!children.IsHeader && cell.IsEditable" type="number" min="0"
                                           class="form-control text-center"
                                           [(ngModel)]="cell.Quantity"
                                           [disabled]="adjPTRunning ? loadDataPT ? true : children.LineNumber != 2  : !canEditAdjust"
                                           onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                           onfocus="if(this.value==='0'){this.value=''}"
                                           onfocusout="if(this.value===''||this.value===null||this.value===undefined){this.value=0;}"
                                           (ngModelChange)="updateParentValue(line, cell)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- fin hijos colapsables -->


            </div>
        </div>
    </div>
</div>